// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#aiStudioWrap{background-color:#2c2c2c}", "",{"version":3,"sources":["webpack://./_editor/components/toolbar/ai_studio/_aiStudioToolbar.scss","webpack://./sass/general/_variables.scss"],"names":[],"mappings":"AAIA,cACE,wBCoBQ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
